// PRD 15 §4.3 display format: "YYYY.MM.DD HH:MM" (24-hour). Null → "-".
const pad = (n: number) => String(n).padStart(2, '0');

export function formatLastLogin(iso: string | null): string {
  if (!iso) return '-';
  const d = new Date(iso);
  return `${d.getFullYear()}.${pad(d.getMonth() + 1)}.${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
